export const getTableBodyHeights = () => {
  const tableHeight =
    ((window.innerHeight - 210 - 52 - 1) / window.innerHeight) * 100;
  return {
    maxBodyHeight: `${tableHeight}vh`,
    minBodyHeight: `${tableHeight}vh`,
  };
};
